import React from 'react';
import CustomButton, { CustomButtonProps } from 'components/Common/Button';

interface LoadMoreButtonProps extends CustomButtonProps {}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = (props) => {
    return (
        <CustomButton
            variant="outlined"
            backgroundColor="none"
            title="Load More"
            sx={{
                alignSelf: 'center',
                margin: 5,
                width: {
                    xs: '66%',
                    md: '30%',
                },
            }}
            {...props}
        />
    );
};

export default LoadMoreButton;
